import AttachmentView from './AttachmentView';

export default AttachmentView;


// WEBPACK FOOTER //
// /src/components/commonComponents/attachmentView/index.js